export const GET_SIGNATURE_REQUEST = 'GET_SIGNATURE_REQUEST';
export const GET_SIGNATURE_REQUEST_SUCCESS = 'GET_SIGNATURE_REQUEST_SUCCESS';

export const SIGN_SIGNATURE_REQUEST = 'SIGN_SIGNATURE_REQUEST';
export const SIGN_SIGNATURE_REQUEST_SUCCESS = 'SIGN_SIGNATURE_REQUEST_SUCCESS';
